import { Injectable } from '@angular/core';
import { generateClient } from '@aws-amplify/api';
import {
  GraphQLResult,
  GraphqlSubscriptionResult,
} from '@aws-amplify/api-graphql';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppSync {
  private client = generateClient();

  constructor() {}

  /**
   * Manejo de SUBSCRIPCIONES con autenticación específica
   */
  public subscribeGraphQLAppSyncWithAuth<T>(options: {
    query: string;
    variables?: { [key: string]: any };
    authMode?: 'apiKey' | 'userPool' | 'iam';
  }): Observable<T> {
    return new Observable((observer) => {
      // Iniciando subscription con authMode

      const graphqlOptions: any = {
        query: options.query,
        variables: options.variables,
      };

      // Agregar authMode si se especifica
      if (options.authMode) {
        graphqlOptions.authMode = options.authMode;
      }

      const result = this.client.graphql(graphqlOptions);

      // Caso SUBSCRIPTION → trae .subscribe()
      if ('subscribe' in result) {
        const sub = (result as GraphqlSubscriptionResult<T>).subscribe({
          next: ({ data }) => {
            if (data) {
              // Datos recibidos en subscription
              observer.next(data);
            }
          },
          error: (err) => {
            console.error('❌ Error en subscription:', err);
            observer.error(err);
          },
        });

        return () => sub.unsubscribe();
      }

      // Si no era subscription
      observer.error(new Error('Not a subscription query'));
      return () => {};
    });
  }

  /**
   * Manejo de SUBSCRIPCIONES (método original)
   */
  public subscribeGraphQLAppSync<T>(options: {
    query: string;
    variables?: { [key: string]: any };
  }): Observable<T> {
    return new Observable((observer) => {
      const result = this.client.graphql({
        query: options.query,
        variables: options.variables,
      });

      // Caso SUBSCRIPTION → trae .subscribe()
      if ('subscribe' in result) {
        const sub = (result as GraphqlSubscriptionResult<T>).subscribe({
          next: ({ data }) => {
            if (data) {
              observer.next(data);
            }
          },
          error: (err) => observer.error(err),
        });

        return () => sub.unsubscribe();
      }

      // Si no era subscription
      observer.error(new Error('Not a subscription query'));
      return () => {};
    });
  }

  /**
   * Manejo de QUERIES/MUTATIONS
   */
  public async queryGraphQLAppSync<T>(options: {
    query: string;
    variables?: { [key: string]: any };
  }): Promise<T> {
    const response = (await this.client.graphql({
      query: options.query,
      variables: options.variables,
    })) as unknown as GraphQLResult<T>; // 👈 pasamos por unknown

    if (!response.data) {
      throw new Error('No data returned from query');
    }

    return response.data;
  }
}
